import EntityType from "../../enum/EntityType";
import { ChatRecordParentEntityType, ChatRouteStopEntityType } from "../../types/chat/ChatContent";
import { ChatContextEntityType } from "../../types/chat/ChatMessage";

// Guards `JSON.parse` output and any nested wire object before indexing into it. Shared by
// parseChatResponse.ts and parseRecordList.ts so there is one declaration, not two that could
// drift apart.
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

// Only these four are valid on the wire; every other EntityType member would be rejected. Used
// by every wire parser that reads an entityType, so the valid set stays defined in one place.
export const CONTEXT_ENTITY_TYPES: ChatContextEntityType[] = [
  EntityType.ACTIVITY,
  EntityType.COMPANY,
  EntityType.DEAL,
  EntityType.PERSON,
];

// The parent-record list, one member shorter than CONTEXT_ENTITY_TYPES above: Activities are legal
// as a message context but never as a parent record or a record_update target. Lives here beside its
// sibling rather than in parseProposals.ts, which parseRecordUpdateAction.ts imports FROM — putting
// it there closed a cycle between the two parsers.
export const RECORD_PARENT_ENTITY_TYPES: ChatRecordParentEntityType[] = [
  EntityType.COMPANY,
  EntityType.DEAL,
  EntityType.PERSON,
];

// A route stop's record, one member shorter again than RECORD_PARENT_ENTITY_TYPES above: a stop is
// never a Deal. Lives here with its two siblings so the valid sets stay in one place.
export const ROUTE_STOP_ENTITY_TYPES: ChatRouteStopEntityType[] = [
  EntityType.COMPANY,
  EntityType.PERSON,
];
